import {fields} from '@/modules/configuration/contants/historianOffices.form';
import HistorianOfficesApiService from '@/modules/configuration/services/HistorianOfficesApiService';
import {createFieldsHook} from '@/utils/createFieldsHook';
import {createGetOneHook} from '@/utils/createGetOneHook';

export const useGetOneHistorianOffices = createGetOneHook(HistorianOfficesApiService, 'id');

export const useFields = createFieldsHook('historian', fields);
